module.exports = __webpack_public_path__ + "static/web-6-5655077e7421921f978fcacc56833b01.mp4";